import { Component } from '@angular/core';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';

@Component({
  selector: 'em-cost-details',
  templateUrl: './cost-details.component.html',
  standalone: false,
})
export class CostDetailsComponent {
  public equipment$ = this.equipmentFacade.equipmentDetails$;
  public hasData$ = this.equipmentFacade.hasData$;
  public hasNoData$ = this.equipmentFacade.hasNoData$;
  public hasError$ = this.equipmentFacade.hasError$;
  public loading$ = this.equipmentFacade.loading$;

  public constructor(private readonly equipmentFacade: EquipmentFacadeService) {}
}
